'use strict';

/* challengerankingPopup Controller */
angular.module('game')
  .directive('rankingPopup', function () {
    return {
      restrict: 'A',
      templateUrl: 'app/partials/home-page/popup/ranking-popup.html',
      scope: {},
      controller: function ($scope, $rootScope, i18nService) {

        // Get the popup API
        $scope.$watch('rankingPopupAPI', function () {
          if ($scope.rankingPopupAPI) {
            $scope.$parent[$scope.popupAttr] = $scope.rankingPopupAPI.addClass('ranking-popup-container');
          }
        });

      },
      link: function (scope, element, attrs) {

        scope.element = angular.element(element);
        var rankingAttr = attrs['ranking'];

        // This is the attribute that will expose the API to the wrapper controller
        if (!rankingAttr) {
          rankingAttr = 'rankingPopupAPI';
        }
        scope.popupAttr = rankingAttr;

      }
    }
  });